import React, { Component } from "react";
import Flexbox from 'flexbox-react';
import ShopListRow from '../shop_list/shop_list_row';
import {observer, inject} from 'mobx-react';

const shopListWidgetWrapper = {
    fontSize: "1vh"
};

@inject('RootStore')
@observer
export default class ShopListWidget extends Component {
    render() {
        let shopList = [];
        for(let i = 0; i <= this.props.RootStore.hallStore.shopsList.length-1; i++) {
            shopList.push(<Flexbox height="2%"  flexGrow={1} key={i + this.props.RootStore.hallStore.shopsList.length+3}></Flexbox>);
            shopList.push(<Flexbox height="15%"><ShopListRow key={i} shop1={this.props.RootStore.hallStore.shopsList[i]}/></Flexbox>)
        }
        shopList.push(<Flexbox height="2%"  flexGrow={1} key={this.props.RootStore.hallStore.shopsList.length + 10}></Flexbox>);
        return (
            <Flexbox height="100%" width="100%" flexDirection='row' style={shopListWidgetWrapper}>
                <Flexbox height="100%" width="10%" ></Flexbox>
                <Flexbox height="100%" width="80%" flexDirection="column">
                    {shopList}
                </Flexbox>
                <Flexbox height="100%" width="10%" ></Flexbox>
            </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/food_court_shop_list_panel/shop_list_widget.jsx